import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=8b41760c&"
import script from "./CurrencySelect.vue?vue&type=script&lang=ts&"
export * from "./CurrencySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports